'use client';

import React from 'react';
import Icon from '@/components/ui/AppIcon';

interface EmergencyHeaderProps {
  onSearchChange: (query: string) => void;
}

const EmergencyHeader: React.FC<EmergencyHeaderProps> = ({ onSearchChange }) => {
  return (
    <div className="bg-gradient-to-r from-error to-destructive text-white py-12 px-4">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-center justify-center mb-4">
          <Icon name="ExclamationTriangleIcon" size={48} variant="solid" className="text-white" />
        </div>
        <h1 className="text-4xl md:text-5xl font-headline font-bold text-center mb-4">
          Emergency Pet Care Resources
        </h1>
        <p className="text-lg md:text-xl text-center text-white/90 mb-8 max-w-3xl mx-auto">
          Immediate access to critical care information, emergency protocols, and 24/7 expert support for urgent pet situations
        </p>
        
        <div className="max-w-2xl mx-auto">
          <div className="relative">
            <Icon 
              name="MagnifyingGlassIcon" 
              size={20} 
              variant="outline" 
              className="absolute left-4 top-1/2 -translate-y-1/2 text-muted-foreground"
            />
            <input
              type="text"
              placeholder="Search emergency protocols, symptoms, or conditions..."
              onChange={(e) => onSearchChange(e.target.value)}
              className="w-full pl-12 pr-4 py-4 rounded-lg text-foreground focus:outline-none focus:ring-2 focus:ring-white/50"
            />
          </div>
        </div>

        <div className="mt-8 flex flex-wrap justify-center gap-4">
          <a
            href="tel:1-800-PET-HELP"
            className="flex items-center space-x-2 px-6 py-3 bg-white text-error font-semibold rounded-lg hover:shadow-lg transition-all duration-300"
          >
            <Icon name="PhoneIcon" size={20} variant="solid" />
            <span>24/7 Hotline: 1-800-PET-HELP</span>
          </a>
          <a
            href="tel:1-888-POISON-1"
            className="flex items-center space-x-2 px-6 py-3 bg-warning text-foreground font-semibold rounded-lg hover:shadow-lg transition-all duration-300"
          >
            <Icon name="ShieldExclamationIcon" size={20} variant="solid" />
            <span>Poison Control: 1-888-POISON-1</span>
          </a>
        </div>
      </div>
    </div>
  );
};

export default EmergencyHeader;